var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F1F6FF",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7F97C3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "m10.4 18.8 3.21-3.21a1.4 1.4 0 0 1 1.98 0l3.21 3.21m-1.4-1.4 1.11-1.11a1.4 1.4 0 0 1 1.98 0l1.11 1.11m-4.2-4.2h.007M11.8 21.6h8.4a1.4 1.4 0 0 0 1.4-1.4v-8.4a1.4 1.4 0 0 0-1.4-1.4h-8.4a1.4 1.4 0 0 0-1.4 1.4v8.4a1.4 1.4 0 0 0 1.4 1.4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.1c3da45363167db1e84e9b9b153bd8ad.svg";
export { ForwardRef as ReactComponent };